import { HTTP, HTTPOriginal } from '@awesome-cordova-plugins/http/';
import { LoggedInApp } from './App';
import { error } from './components/ToastController';

export function backendUrl()
{
    return "https://icurety.com:7878/";
}

export function isWeb() {
    return true;
}

//Used to mimic the response returned from the fetch API 
//so that we can maintain a single code base between web and native
export class FetchResponse {
    public ok: any;
    public status: any;
    public data: any;

    constructor(ok: any, status: any, data: any)
    {
        this.ok = ok;
        this.status = status;
        this.data = data;
    }

    json = (): any => {
        return new Promise((resolve, reject) => {
            resolve(JSON.parse(this.data));
        });
    }

    text = (): any => {
        return new Promise((resolve, reject) => {
            resolve(this.data);
        })
    }
}


export function getJson(path: string)
{
    if(isWeb()) {
        return fetch(backendUrl() + path, {
            method: "GET",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            }
        }).catch(ex => {
            console.log(ex);
            if(LoggedInApp.inTabbedView()) {
                LoggedInApp.goToOfflinePage();
            }
            else {
                error("Kunne ikke oprette forbindelse");
            }
            return new FetchResponse(false, 0, "Ingen forbindelse til server");
        });
    }
    else {
        return HTTP.get(backendUrl() + path, {}, {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        }).then(response => {
            return new FetchResponse(response.status === 200, response.status, response.data);
        }, () => {
            if(LoggedInApp.inTabbedView()) {
                LoggedInApp.goToOfflinePage();
            }
            else {
                error("Kunne ikke oprette forbindelse");
            }
    
            return new FetchResponse(false, 0, "Ingen forbindelse til server");
        })
    }
}



export function postJson(path: string, jsonBody: any)
{

    if(isWeb()) 
    {
        return fetch(backendUrl() + path, {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
              },
            body: JSON.stringify(jsonBody)
        }).catch(ex => {
            if(LoggedInApp.inTabbedView()) {
                LoggedInApp.goToOfflinePage();
            }
            else {
                error("Kunne ikke oprette forbindelse");
            }
            return new FetchResponse(false, 0, "Ingen forbindelse til server");
        });
    }
    else {
        return HTTP.post(backendUrl() + path, jsonBody, {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        }).then(response => {
            return new FetchResponse(response.status === 200, response.status, response.data);
        }, () => {
            if(LoggedInApp.inTabbedView()) {
                LoggedInApp.goToOfflinePage();
            }
            else {
                error("Kunne ikke oprette forbindelse");
            }
            
            return new FetchResponse(false, 0, "Ingen forbindelse til server");
        })
    }
}

export function deleteRequest(path: string)
{

    if(isWeb()) {
        return fetch(backendUrl() + path, {
            method: "DELETE",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
        }).catch(ex => {
            if(LoggedInApp.inTabbedView()) {
                LoggedInApp.goToOfflinePage();
            }
            else {
                error("Kunne ikke oprette forbindelse");
            }
            return new FetchResponse(false, 0, "Ingen forbindelse til server");
        });
    }
    else {
        return HTTP.delete(backendUrl() + path, {}, {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        }).then(response => {
            return new FetchResponse(response.status === 200, response.status, response.data);
        }, () => {
            if(LoggedInApp.inTabbedView()) {
                LoggedInApp.goToOfflinePage();
            }
            else {
                error("Kunne ikke oprette forbindelse");
            }
    
            return new FetchResponse(false, 0, "Ingen forbindelse til server");
        })
    }
}